import { TypeJuridiction } from '../../entities/type-juridiction';
import { TypeActeAttaque } from '../../entities/type-acte-attaque';
import { ContentieuxSocial } from '../../entities/contentieux-social';
import { TypeRaisonContestation } from '../../entities/type-raison-contestation';
import { TypeRaisonInvalidationTitre } from '../../entities/type-raison-invalidation-titre';
import { TypePrejudiceEvaluableEnArgent } from '../../entities/type-prejudice-evaluable-en-argent';
import { TypeRaisonAvisDimpositionIrregulier } from '../../entities/type-raison-avis-dimposition-irregulier';

export interface Country {
    isoCode: string;
    label: string;
}

export interface Parameters {
    countries: Array<Country>;
    juridictions: Array<TypeJuridiction>;
    typeRaisonContestations: Array<TypeRaisonContestation>;
    typeRaisonInvalidationTitres: Array<TypeRaisonInvalidationTitre>;
    typeRaisonAvisDimpositionIrreguliers: Array<TypeRaisonAvisDimpositionIrregulier>;
    typePrejudiceEvaluableEnArgents: Array<TypePrejudiceEvaluableEnArgent>;
    contentieuxSociaux: Array<ContentieuxSocial>;
    civilities: Array<string>;
    typeActeAttaques: Array<TypeActeAttaque>;
    maxFileNameWithoutExtensionLength: number;
    maxFileSize: number;
    maxActeAttaquesForMerge: number;
}

export const DEFAULT_PARAMETERS: Parameters = {
    countries: [],
    juridictions: [],
    typeRaisonContestations: [],
    typeRaisonInvalidationTitres: [],
    typeRaisonAvisDimpositionIrreguliers: [],
    typePrejudiceEvaluableEnArgents: [],
    contentieuxSociaux: [],
    civilities: [],
    typeActeAttaques: [],
    maxFileNameWithoutExtensionLength: 220,
    maxFileSize: 32 * 1024 * 1024,
    maxActeAttaquesForMerge: 10
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/model/parameters.model.ts